// This is the main webpack entrypoint for setting up globals that
// should be available throughout bubblesheet-core.

import { SCORE_INTAKE, kinesisConnection } from '../scoring/scoreIntake';
import MultiChoice from '../MultiChoice';
import MultiSelect from '../MultiSelect';
import TrueFalse from '../TrueFalse';
import { StandardOrator } from '../StandardOrator';
import * as SentryUtil from '../SentryUtil';

export default function BubblesheetCoreSetup () {
  window.SCORE_INTAKE = SCORE_INTAKE;
  window.kinesisConnection = kinesisConnection;

  window.BubblesheetCore = {
    MultiChoice: MultiChoice,
    MultiSelect: MultiSelect,
    TrueFalse: TrueFalse
  };

  window.StandardOrator = StandardOrator;
  window.MCSentryUtil = SentryUtil;

  if (!window._t) {
    window._t = function (key) {
      return key;
    };
  }
}
